import { UserResponse } from "authory-api-types";
import { ProfileComponentType } from "authory-api-types";

export const getTwitterProfileComponent = (user: UserResponse) =>
    user.profileComponents.find((profileComponent) => profileComponent.type === ProfileComponentType.TwitterLink);
